function getUrl(enabledTools, toolName) {
  return enabledTools?.find((e) => e.name === toolName)?.url;
}

const enabledToolsUtils = {
  getUrl,
};

export default enabledToolsUtils;
